import { render, staticRenderFns } from "./PatrolObject.vue?vue&type=template&id=b0a33732&scoped=true"
import script from "./PatrolObject.vue?vue&type=script&lang=js"
export * from "./PatrolObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a33732",
  null
  
)

export default component.exports